import {AppData} from "../shared/models/AppData";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export type AppState = AppData;

function createInitialState(): AppState {
  return {
    languages: [],
    countries: [],
    nationalities: [],
    residences: [],
    requests: []
  };
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'project'
})
export class ProjectStore extends Store<AppState> {
  constructor() {
    super(createInitialState());
  }
}
